import { useState, useEffect, useContext } from 'react'
import { NavLink, useLocation } from 'react-router-dom'
import logo from '../assets/logo_bg.webp'
import { IoIosLogIn } from "react-icons/io"
import { FaArrowRight } from "react-icons/fa6"
import { IoMdClose } from "react-icons/io";
import { useTr, usePathLang } from '../lib/i18n'
import { NAV_CATEGORIES, navCategoryPath, homePath, contactPath, aboutPath, switchLangPath } from '../lib/ru'

const ResponsiveMenu = ({ showRespMenu, setShowRespMenu, saleType }) => {
    const location = useLocation();
    const [openSection, setOpenSection] = useState(null);
    const lang = usePathLang()
    const tr = (ro, ru) => (lang === 'ru' ? ru : ro)

    const toggleSection = (section) => {
        setOpenSection((prev) => (prev === section ? null : section));
    };

    const categoryLinks = (saleTypeVal) =>
        NAV_CATEGORIES.map((c) => [tr(c.label, c.ruLabel), navCategoryPath(lang, c.base, saleTypeVal)]);

    useEffect(() => {
        const handleResize = () => {
            if (window.innerWidth >= 1024) {
                setShowRespMenu(false);
            }
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, [setShowRespMenu]);

    if (!showRespMenu) return null;

    return (
        <>
            <div className='fixed top-0 left-0 z-[300] h-screen w-full bg-black/50' onClick={() => setShowRespMenu(false)} />
            <div className="fixed top-0 left-0 z-[301] h-screen w-full max-w-[340px] bg-white overflow-y-auto">
                <div className='flex flex-col gap-[10px] px-[25px] py-[25px]'>
                    <div className='flex justify-between items-center'>
                        <NavLink to={homePath(lang)} onClick={() => { setShowRespMenu(false); }}>
                            <img src={logo} alt={tr('LVG Imob - Companie imobiliară - Logo', 'LVG Imob - Компания недвижимости - Логотип')} className='w-[110px] rounded-[5px]' />
                        </NavLink>
                        <IoMdClose className='text-3xl cursor-pointer text-[#181616]' onClick={() => setShowRespMenu(false)} />
                    </div>

                    <ul>
                        <li className='text-[#181616] cursor-pointer duration-75 ease-in transition-all relative'>
                            <NavLink to={homePath(lang)} end className={({ isActive }) => `block w-full py-[15px] ${'text-[18px] font-[500] font-poppins'} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}`} onClick={() => { setShowRespMenu(false); }}>
                                {tr('Acasă', 'Главная')}
                            </NavLink>
                            <span className='block absolute bottom-0 left-0 border-t-[1px] bg-gray-300 opacity-[0.2] w-full'></span>
                        </li>

                        <li className='text-[#181616] cursor-pointer duration-75 ease-in transition-all relative'>
                            <div className="flex items-center justify-between" onClick={() => toggleSection('chirie')}>
                                <p className={`block w-full py-[15px] ${'text-[18px] font-[500] font-poppins'} ${saleType === '2' ? "text-[#d5ab63]" : ""}`}>{tr('Chirie', 'Аренда')}</p>
                                <span className={`transition-transform duration-150 ${openSection === 'chirie' ? 'rotate-180' : ''}`}>▼</span>
                            </div>
                            <span className='block absolute bottom-0 left-0 border-t-[1px] bg-gray-300 opacity-[0.2] w-full'></span>
                            {openSection === 'chirie' && (
                                <div className='flex flex-col gap-[5px] pb-[10px] pt-[10px]'>
                                    {categoryLinks(2).map(([label, to]) => (
                                        <NavLink key={to} to={to} onClick={() => { setShowRespMenu(false); }} className="block w-full py-[9px] pl-[16px] text-[15px] font-body text-gray-700 hover:text-[#d5ab63] transition-colors duration-100 ease-in">
                                            {label}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li className='text-[#181616] cursor-pointer duration-75 ease-in transition-all relative'>
                            <div className="flex items-center justify-between" onClick={() => toggleSection('vanzare')}>
                                <p className={`block w-full py-[15px] ${'text-[18px] font-[500] font-poppins'} ${saleType === '1' ? "text-[#d5ab63]" : ""}`}>{tr('Vânzare', 'Продажа')}</p>
                                <span className={`transition-transform duration-150 ${openSection === 'vanzare' ? 'rotate-180' : ''}`}>▼</span>
                            </div>
                            <span className='block absolute bottom-0 left-0 border-t-[1px] bg-gray-300 opacity-[0.2] w-full'></span>
                            {openSection === 'vanzare' && (
                                <div className='flex flex-col gap-[5px] pb-[10px] pt-[10px]'>
                                    {categoryLinks(1).map(([label, to]) => (
                                        <NavLink key={to} to={to} onClick={() => { setShowRespMenu(false); }} className="block w-full py-[9px] pl-[16px] text-[15px] font-body text-gray-700 hover:text-[#d5ab63] transition-colors duration-100 ease-in">
                                            {label}
                                        </NavLink>
                                    ))}
                                </div>
                            )}
                        </li>

                        <li className='text-[#181616] cursor-pointer duration-75 ease-in transition-all relative'>
                            <NavLink to={aboutPath(lang)} onClick={() => { setShowRespMenu(false); }} className={({ isActive }) => `block w-full py-[15px] ${'text-[18px] font-[500] font-poppins'} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}`}>
                                {tr('Despre noi', 'О нас')}
                            </NavLink>
                            <span className='block absolute bottom-0 left-0 border-t-[1px] bg-gray-300 opacity-[0.2] w-full'></span>
                        </li>
                        <li className='text-[#181616] cursor-pointer duration-75 ease-in transition-all relative'>
                            <NavLink to={contactPath(lang)} onClick={() => { setShowRespMenu(false); }} className={({ isActive }) => `block w-full py-[15px] ${'text-[18px] font-[500] font-poppins'} ${isActive ? "text-[#d5ab63]" : "hover:text-[#d5ab63]"}`}>
                                {tr('Contacte', 'Контакты')}
                            </NavLink>
                            <span className='block absolute bottom-0 left-0 border-t-[1px] bg-gray-300 opacity-[0.2] w-full'></span>
                        </li>
                        <li className='mt-[50px]'>
                            <NavLink to={lang === 'ru' ? '/ru/cerere' : '/cerere'}
                                className={`flex gap-[10px] justify-center items-center uppercase font-[500] text-[14px] px-[30px] py-[18px] rounded-[5px] transition-all duration-100 ease-in border-[1px] border-gray-300 text-[#181616] hover:bg-gray-300`}
                                onClick={() => { setShowRespMenu(false); }}
                            >
                                <span>{tr('Vreau să vând', 'Хочу продать')}</span>
                                <FaArrowRight className="text-lg text-[#d5ab63]" />
                            </NavLink>
                        </li>
                        <li className='mt-[10px]'>
                            <NavLink
                                to={switchLangPath(location.pathname)}
                                className="block w-full text-center uppercase font-[500] text-[14px] px-[30px] py-[16px] rounded-[5px] transition-all duration-100 ease-in border-[1px] border-gray-300 text-[#181616] hover:bg-gray-300"
                                onClick={() => { setShowRespMenu(false); }}
                            >
                                <span>{location.pathname.startsWith('/ru') ? 'RO' : 'RU'}</span>
                            </NavLink>
                        </li>
                    </ul>
                </div>
            </div>
        </>
    )
}

export default ResponsiveMenu
